import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { fetchRecords } from './failed-emails.action';
import { selectData } from './failed-emails-selector';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FailedEmailsTableService {

    constructor(
        private store: Store<RootReducerState>,
    ) { 
        this.recordsList$ = this.store.select(selectData);
        this.store.select(selectData)
                    .subscribe((selectData) => {
                        // console.log("In bulktable service.ts");
                        this.allCurrentValues = [];
                        if(selectData?.length > 0){
                            selectData.forEach((row: any) => {
                                this.allCurrentValues.push(row.id);
                            });
                        }
                    });
    }
 
    recordsList$: Observable<any>;
    pagination = [];
    filters = {
                created_at: '',
                dossier_id: '',
                dossier_categories_name: null,
                to_email: '',
                subject: '',
                tries: '',
                status_text: null
            };

    page: number = 1;
    lastPage: number;
    limit: number = 10;
    initialSortColumn = 'created_at';
    initialSortDirection = 'desc';
    sortColumn = this.initialSortColumn;
    sortDirection = this.initialSortDirection;
    hasFilter = false;
    categories = [];

    allSelectionValues: Set<number> = new Set();
    allCurrentValues = [];
    allCheckboxValue: boolean = false;

    columns = [
                { prop: 'checkbox', name: '', sortable: false, hasFilter: false, checkAllBox: true, filter: "input", widthSet: 40},
                { prop: 'created_at', name: 'FAILED_EMAILS.date-time', sortable: true, hasFilter: true, filter: "date", widthSet: 160},
                { prop: 'dossier_id', name: 'FAILED_EMAILS.dossier-id', sortable: true, hasFilter: true, filter: "input", widthSet: 80},
                { prop: 'dossier_categories_name', name: 'FAILED_EMAILS.category', sortable: true, hasFilter: true, filter: "select", options: 'categories', options_id: "id", options_label: "name", widthSet: 185},
                { prop: 'to_email', name: 'FAILED_EMAILS.recipient', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'subject', name: 'FAILED_EMAILS.subject', sortable: true, hasFilter: true, filter: "input", widthSet: 400},
                { prop: 'tries', name: 'FAILED_EMAILS.tries', sortable: true, hasFilter: true, filter: "input", widthSet: 70},
                { prop: 'status_text', name: 'COMMON.status', sortable: false, hasFilter: false, filter: "select", options: 'statuses', options_id: "id", options_label: "name", widthSet: 140},
                { prop: 'actions', name: 'COMMON.actions', sortable: false, hasFilter: false, filter: ""}
            ];

    loadRecords() {
        this.allCheckboxValue = false;
        this.hasFilter = this.hasActiveFilters();
        this.store.dispatch(fetchRecords());
    }

    hasActiveFilters(){

        if(
            (Object.values(this.filters).some(value => value !== '' && value !== null)) ||
            (this.sortDirection !== this.initialSortDirection || this.sortColumn !== this.initialSortColumn)
        )
            return true;
        else
            return false;        
    }

    resetState(){
        this.allCheckboxValue = false;
        this.filters = {
            created_at: '',
            dossier_id: '',
            dossier_categories_name: null,
            to_email: '',
            subject: '',
            tries: '',
            status_text: null
        }

        this.sortDirection = this.initialSortDirection;
        this.sortColumn = this.initialSortColumn;
    }

    resetFilters(){
        this.resetState();
        this.loadRecords();
    }

    allSelection(event){
        
        let checked = (event.target as HTMLInputElement).checked;
        if(checked){
            this.allCheckboxValue = true;
            this.allCurrentValues.forEach(id => {
                if (!this.allSelectionValues.has(id))
                    this.allSelectionValues.add(id);
            });
        }else{
            this.allCheckboxValue = false;
            this.allCurrentValues.forEach(id => {
                this.allSelectionValues.delete(id)
            });
        }

    }

}